import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { useRef } from 'react';

export const FeesForecastPerspective = () => {

  const entityPerspectiveRef = useRef();

  const views = [
      {
        name: 'FFS',
        dims: ['RBT_PERIOD','PROD'],
        kpis: ['INV_QTY','GROSS_SALES','NBF_FEES','BF_FEES','TOTAL_FEES'],
        dimToPeriodicities: {
          RBT_PERIOD: ['QTR']
        }
      },
      {
        name: 'RDC',
        dims: ['RBT_PERIOD','PROD'],
        kpis: ['INV_QTY','GROSS_SALES','BF_FEES','TOTAL_FEES'],
        dimToPeriodicities: {
          RBT_PERIOD: ['QTR']
        }
      }
    ]
  

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      entity = {'FEES_FORECAST'}
    />
  )
}